import { render } from "./myInfo.vue?vue&type=template&id=642afe07&scoped=true&ts=true"
import script from "./myInfo.vue?vue&type=script&lang=ts&config=true"
export * from "./myInfo.vue?vue&type=script&lang=ts&config=true"

import "./myInfo.vue?vue&type=style&index=0&id=642afe07&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642afe07"]])

export default __exports__